package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings


enum class DiscountNoEnum(val value: Int) {
    NONE(0),
    DISCOUNT_GROUP_1(1),
    DISCOUNT_GROUP_2(2),
    DISCOUNT_GROUP_3(3),
    DISCOUNT_GROUP_4(4),
    DISCOUNT_GROUP_5(5),
    DISCOUNT_GROUP_6(6),
    DISCOUNT_GROUP_7(7),
    DISCOUNT_GROUP_8(8),
    DISCOUNT_GROUP_9(9),
    DISCOUNT_GROUP_10(10),
    DISCOUNT_GROUP_11(11),
    DISCOUNT_GROUP_12(12),
    DISCOUNT_GROUP_13(13),
    DISCOUNT_GROUP_14(14),
    DISCOUNT_GROUP_15(15),
    DISCOUNT_GROUP_16(16),
    DISCOUNT_GROUP_17(17),
    DISCOUNT_GROUP_18(18),
    DISCOUNT_GROUP_19(19),
    DISCOUNT_GROUP_20(20);

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            NONE -> strings.none
            DISCOUNT_GROUP_1 -> strings.discountGroup1
            DISCOUNT_GROUP_2 -> strings.discountGroup2
            DISCOUNT_GROUP_3 -> strings.discountGroup3
            DISCOUNT_GROUP_4 -> strings.discountGroup4
            DISCOUNT_GROUP_5 -> strings.discountGroup5
            DISCOUNT_GROUP_6 -> strings.discountGroup6
            DISCOUNT_GROUP_7 -> strings.discountGroup7
            DISCOUNT_GROUP_8 -> strings.discountGroup8
            DISCOUNT_GROUP_9 -> strings.discountGroup9
            DISCOUNT_GROUP_10 -> strings.discountGroup10
            DISCOUNT_GROUP_11 -> strings.discountGroup11
            DISCOUNT_GROUP_12 -> strings.discountGroup12
            DISCOUNT_GROUP_13 -> strings.discountGroup13
            DISCOUNT_GROUP_14 -> strings.discountGroup14
            DISCOUNT_GROUP_15 -> strings.discountGroup15
            DISCOUNT_GROUP_16 -> strings.discountGroup16
            DISCOUNT_GROUP_17 -> strings.discountGroup17
            DISCOUNT_GROUP_18 -> strings.discountGroup18
            DISCOUNT_GROUP_19 -> strings.discountGroup19
            DISCOUNT_GROUP_20 -> strings.discountGroup20
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                NONE -> strings.none
                DISCOUNT_GROUP_1 -> strings.discountGroup1
                DISCOUNT_GROUP_2 -> strings.discountGroup2
                DISCOUNT_GROUP_3 -> strings.discountGroup3
                DISCOUNT_GROUP_4 -> strings.discountGroup4
                DISCOUNT_GROUP_5 -> strings.discountGroup5
                DISCOUNT_GROUP_6 -> strings.discountGroup6
                DISCOUNT_GROUP_7 -> strings.discountGroup7
                DISCOUNT_GROUP_8 -> strings.discountGroup8
                DISCOUNT_GROUP_9 -> strings.discountGroup9
                DISCOUNT_GROUP_10 -> strings.discountGroup10
                DISCOUNT_GROUP_11 -> strings.discountGroup11
                DISCOUNT_GROUP_12 -> strings.discountGroup12
                DISCOUNT_GROUP_13 -> strings.discountGroup13
                DISCOUNT_GROUP_14 -> strings.discountGroup14
                DISCOUNT_GROUP_15 -> strings.discountGroup15
                DISCOUNT_GROUP_16 -> strings.discountGroup16
                DISCOUNT_GROUP_17 -> strings.discountGroup17
                DISCOUNT_GROUP_18 -> strings.discountGroup18
                DISCOUNT_GROUP_19 -> strings.discountGroup19
                DISCOUNT_GROUP_20 -> strings.discountGroup20
            }
        }
}